import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class scores
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.scores = {};

/**
 * GET Endpoint `/scores`
 * @param {number} widget_id
 * @param {ReachAPI.Security} security
 * @param {string} timezone
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.scores
 */
ReachAPI.scores.get = function (widget_id, security, timezone) {
    var url = ReachAPI.server + '/scores';
    var params = {
        widget_id: widget_id,
        timezone: timezone,
        format: 'json',
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Scores from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Scores from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Scores',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
